/**
 * BackgroundMask component
 */
import AccessActionsContainer from '@components/atoms/container/accessActionsContainer';
import AccessBackgroundContainer from '@components/atoms/container/accessBackgroundContainer';
import AccessImageContainer from '@components/atoms/container/accessImageContainer';
import AccessLogo from '@components/atoms/images/accessLogo';
import { DELAY } from '../../../../shared/types/constants/animations';

/**
 * This component displays several masks that cover the background of the app.
 */
export default function AccessBackground() {
  // ------------------------------------------------------------
  // Render
  // ------------------------------------------------------------

  return (
    <AccessBackgroundContainer delay={DELAY.ACCESS_OPACITY}>
      <AccessImageContainer />
      <AccessActionsContainer />
      <AccessLogo key={'logo'} />
    </AccessBackgroundContainer>
  );
}
